module.exports = __webpack_public_path__ + "img/upgrade-plan.77292479.svg";